import { ORG_ROUTE_FEATURES as REGISTRY_ORG_ROUTE_FEATURES } from '@/config/routeAccessRegistry';
import { FEATURE } from '@/core/features/featureCodes';

/** Org routes gated by subscription features (from routeAccessRegistry) */
export const ORG_ROUTE_FEATURES = REGISTRY_ORG_ROUTE_FEATURES;

export const POS_ROUTE_FEATURES: Record<string, string | string[] | null> = {
  '/pos/dashboard': FEATURE.REPORTING,
  '/pos': FEATURE.POS_BILLING,
  '/pos/held': FEATURE.POS_BILLING,
  '/pos/shift': FEATURE.POS_SHIFT_MANAGEMENT,
  '/pos/returns': FEATURE.POS_RETURNS,
  '/pos/analytics': FEATURE.POS_ANALYTICS,
  '/pos/setup': FEATURE.POS_BILLING,
  '/pos/terminal-reports': FEATURE.POS_BILLING,
};
